import Button from '~components/Button';
import Image from '~components/Image';

import * as S from './style';

interface Props {
  PK_NM_HASH: string;
  companyName: string;
  isRecommended: boolean;
  location: string;
  linkMore: string;
  logoThumbnail?: string;
}

export default function CompanyCard({
  PK_NM_HASH,
  companyName,
  isRecommended,
  location,
  linkMore,
  logoThumbnail,
}: Props) {
  return (
    <S.Wrapper>
      <S.LeftArea>
        <S.Logo>
          {!logoThumbnail ? (
            <Image
              alt='company_logo'
              src='https://static.wanted.co.kr/images/kj/default_company_logo.png'
              width={40}
              style={{ width: '25px' }}
            />
          ) : (
            <img src={logoThumbnail} alt='' />
          )}
        </S.Logo>
        <S.CompanyInfo>
          <S.CompanyName>{companyName}</S.CompanyName>
          <S.Address>{location}</S.Address>
        </S.CompanyInfo>
      </S.LeftArea>

      <Button
        variant='magenta'
        size='sm'
        as='a'
        href={linkMore}
        target='_blank'
        data-attribute-id='company__position__seeMore'
        data-company-name={companyName}
        data-company-hash={PK_NM_HASH}
        data-connection={isRecommended ? '추천기업 채용 공고' : '채용 공고'}>
        더 많은 공고 보기
      </Button>
    </S.Wrapper>
  );
}
